import { formatGetHeaders } from '@configurations/api-configuration';
import { MarketAreaGateway } from '@scenario/gateways/market-area.gateway';
import { MarketArea } from '@scenario/models/market-area.model';
import { environment } from '../../../../../environments/environment';

export class ApiMarketAreaGateway implements MarketAreaGateway {
  private readonly marketAreaApi = `${environment.backend_url}/api/v1/marketArea`;

  async retrieveAll(): Promise<MarketArea[]> {
    try {
      const response = await fetch(`${this.marketAreaApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving market areas: ' + error);
    }
  }
}
